import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d596b2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-header" }
const _hoisted_2 = { class: "group-name" }
const _hoisted_3 = { class: "group-cp" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "组内条件关系：", -1))
const _hoisted_5 = { class: "group-operation" }
const _hoisted_6 = { class: "group-content" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_11 = {
  key: 1,
  style: {"margin-left":"10px"}
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { style: {"margin-left":"10px"} }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" ~ ")
const _hoisted_16 = { key: 2 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某组织其中之一", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("选择组织")
const _hoisted_19 = { key: 3 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某组织类型其中之一", -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode("选择组织类型")
const _hoisted_22 = { key: 4 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某部门其中之一", -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode("选择部门")
const _hoisted_25 = { key: 5 }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某岗位其中之一", -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode("选择岗位")
const _hoisted_28 = { key: 6 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某人员其中之一", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("选择人员")
const _hoisted_31 = { key: 7 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某组织其中之一", -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode("选择组织")
const _hoisted_34 = { key: 8 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某组织类型其中之一", -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode("选择组织类型")
const _hoisted_37 = { key: 9 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-desc",
  style: {"margin-right":"20px"}
}, "属于某组织类型其中之一", -1))
const _hoisted_39 = /*#__PURE__*/_createTextVNode("选择组织类型")
const _hoisted_40 = { key: 10 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_app_ellipsis = _resolveComponent("app-ellipsis")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_picker_items = _resolveComponent("picker-items")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_org_picker = _resolveComponent("org-picker")!
  const _component_org_type_picker = _resolveComponent("org-type-picker")!
  const _component_dept_picker = _resolveComponent("dept-picker")!
  const _component_post_picker = _resolveComponent("post-picker")!
  const _component_user_picker = _resolveComponent("user-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedNode.props.groups, (group, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index + '_g',
        class: "group"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, "条件组 " + _toDisplayString(_ctx.groupNames[index]), 1),
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_el_switch, {
              modelValue: group.groupType,
              "onUpdate:modelValue": ($event: any) => ((group.groupType) = $event),
              "active-color": "#409EFF",
              "inactive-color": "#c1c1c1",
              "active-value": "AND",
              "inactive-value": "OR",
              "active-text": "且",
              "inactive-text": "或"
            }, null, 8, ["modelValue", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_popover, {
              placement: "bottom",
              title: "选择审批条件",
              width: "300",
              trigger: "click"
            }, {
              reference: _withCtx(() => [
                _createVNode(_component_el_icon, { size: "2.3em" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox_group, {
                  modelValue: group.cids,
                  "onUpdate:modelValue": ($event: any) => ((group.cids) = $event),
                  "value-key": "id"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionList, (condition, cindex) => {
                      return (_openBlock(), _createBlock(_component_el_checkbox, {
                        label: condition.id,
                        key: condition.id,
                        onChange: ($event: any) => (_ctx.conditionChange(cindex, group))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(condition.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "onChange"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_el_icon, {
              size: "2.3em",
              class: "el-icon-delete",
              onClick: ($event: any) => (_ctx.delGroup(index))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Delete)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (group.conditions.length === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, "点击右上角 + 为本条件组添加条件 ☝"))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_el_form, {
                  ref_for: true,
                  ref: "condition-form",
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.conditions, (condition, cindex) => {
                      return (_openBlock(), _createBlock(_component_el_form_item, {
                        key: condition.id + '_' + cindex
                      }, {
                        label: _withCtx(() => [
                          _createVNode(_component_app_ellipsis, {
                            "hover-tip": "",
                            content: condition.title
                          }, null, 8, ["content"])
                        ]),
                        default: _withCtx(() => [
                          (condition.valueType === _ctx.ValueType.string)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                _createVNode(_component_el_select, {
                                  size: "default",
                                  placeholder: "判断符",
                                  style: {"width":"100px"},
                                  modelValue: condition.compare,
                                  "onUpdate:modelValue": ($event: any) => ((condition.compare) = $event),
                                  onChange: ($event: any) => (condition.value = [])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_option, {
                                      label: "等于",
                                      value: "="
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "不等于",
                                      value: "!="
                                    }),
                                    _createVNode(_component_el_option, {
                                      label: "包含在",
                                      value: "IN"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]),
                                (_ctx.isSelect(condition.id))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                      (condition.compare === 'IN')
                                        ? (_openBlock(), _createBlock(_component_el_select, {
                                            key: 0,
                                            style: {"width":"260px"},
                                            clearable: "",
                                            multiple: "",
                                            size: "default",
                                            modelValue: condition.value,
                                            "onUpdate:modelValue": ($event: any) => ((condition.value) = $event),
                                            placeholder: "选择值"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions(condition.id), (option, oi) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: oi,
                                                  label: option.name,
                                                  value: option.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createBlock(_component_el_select, {
                                            key: 1,
                                            style: {"width":"260px"},
                                            clearable: "",
                                            size: "default",
                                            modelValue: condition.value[0],
                                            "onUpdate:modelValue": ($event: any) => ((condition.value[0]) = $event),
                                            placeholder: "选择值"
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getOptions(condition.id), (option, oi) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: oi,
                                                  label: option.name,
                                                  value: option.value
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue"]))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                      (condition.compare === '=' || condition.compare === '!=')
                                        ? (_openBlock(), _createBlock(_component_el_input, {
                                            key: 0,
                                            style: {"width":"260px"},
                                            placeholder: "输入比较值",
                                            size: "default",
                                            modelValue: condition.value[0],
                                            "onUpdate:modelValue": ($event: any) => ((condition.value[0]) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createBlock(_component_el_select, {
                                            key: 1,
                                            style: {"width":"260px"},
                                            multiple: "",
                                            clearable: "",
                                            filterable: "",
                                            "allow-create": "",
                                            size: "default",
                                            modelValue: condition.value,
                                            "onUpdate:modelValue": ($event: any) => ((condition.value) = $event),
                                            placeholder: "输入可能包含的值"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                    ]))
                              ]))
                            : (condition.valueType === _ctx.ValueType.number)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                  _createVNode(_component_el_select, {
                                    size: "default",
                                    placeholder: "判断符",
                                    style: {"width":"100px"},
                                    modelValue: condition.compare,
                                    "onUpdate:modelValue": ($event: any) => ((condition.compare) = $event)
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.explains, (exp) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: exp.label,
                                          value: exp.value,
                                          key: exp.value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("span", _hoisted_13, [
                                    (_ctx.conditionValType(condition.compare) === 0)
                                      ? (_openBlock(), _createBlock(_component_el_input, {
                                          key: 0,
                                          style: {"width":"260px"},
                                          size: "default",
                                          placeholder: "输入比较值",
                                          type: "number",
                                          modelValue: condition.value[0],
                                          "onUpdate:modelValue": ($event: any) => ((condition.value[0]) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                      : (_ctx.conditionValType(condition.compare) === 1)
                                        ? (_openBlock(), _createBlock(_component_el_select, {
                                            key: 1,
                                            style: {"width":"260px"},
                                            multiple: "",
                                            filterable: "",
                                            "allow-create": "",
                                            size: "default",
                                            modelValue: condition.value,
                                            "onUpdate:modelValue": ($event: any) => ((condition.value) = $event),
                                            placeholder: "输入可能包含的值"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                            _createVNode(_component_el_input, {
                                              style: {"width":"120px"},
                                              size: "default",
                                              type: "number",
                                              placeholder: "输入比较值",
                                              modelValue: condition.value[0],
                                              "onUpdate:modelValue": ($event: any) => ((condition.value[0]) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                            _createElementVNode("span", null, [
                                              _hoisted_15,
                                              _createVNode(_component_el_input, {
                                                size: "default",
                                                style: {"width":"120px"},
                                                type: "number",
                                                placeholder: "输入比较值",
                                                modelValue: condition.value[1],
                                                "onUpdate:modelValue": ($event: any) => ((condition.value[1]) = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ])
                                          ]))
                                  ])
                                ]))
                              : (condition.valueType === _ctx.ValueType.org)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                    _hoisted_17,
                                    _createVNode(_component_el_button, {
                                      size: "default",
                                      icon: "Plus",
                                      type: "primary",
                                      onClick: ($event: any) => (_ctx.orgPickerOpen(condition.value)),
                                      round: ""
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_18
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_picker_items, {
                                      modelValue: condition.value,
                                      "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]))
                                : (condition.valueType === _ctx.ValueType.orgType)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                      _hoisted_20,
                                      _createVNode(_component_el_button, {
                                        size: "default",
                                        icon: "Plus",
                                        type: "primary",
                                        onClick: ($event: any) => (_ctx.orgTypePickerOpen(condition.value)),
                                        round: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_21
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_picker_items, {
                                        modelValue: condition.value,
                                        "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]))
                                  : (condition.valueType === _ctx.ValueType.dept)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, [
                                        _hoisted_23,
                                        _createVNode(_component_el_button, {
                                          size: "default",
                                          icon: "Plus",
                                          type: "primary",
                                          onClick: ($event: any) => (_ctx.deptPickerOpen(condition.value)),
                                          round: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_24
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]),
                                        _createVNode(_component_picker_items, {
                                          modelValue: condition.value,
                                          "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                    : (condition.valueType === _ctx.ValueType.post)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                          _hoisted_26,
                                          _createVNode(_component_el_button, {
                                            size: "default",
                                            icon: "Plus",
                                            type: "primary",
                                            onClick: ($event: any) => (_ctx.postPickerOpen(condition.value)),
                                            round: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_27
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]),
                                          _createVNode(_component_picker_items, {
                                            modelValue: condition.value,
                                            "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]))
                                      : (condition.valueType === _ctx.ValueType.user)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                            _hoisted_29,
                                            _createVNode(_component_el_button, {
                                              size: "default",
                                              icon: "Plus",
                                              type: "primary",
                                              onClick: ($event: any) => (_ctx.userPickerOpen(condition.value)),
                                              round: ""
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_30
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]),
                                            _createVNode(_component_picker_items, {
                                              modelValue: condition.value,
                                              "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                          ]))
                                        : (condition.valueType === _ctx.ValueType.deviceOrg)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                              _hoisted_32,
                                              _createVNode(_component_el_button, {
                                                size: "default",
                                                icon: "Plus",
                                                type: "primary",
                                                onClick: ($event: any) => (_ctx.deviceOrgPickerOpen(condition.value)),
                                                round: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_33
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]),
                                              _createVNode(_component_picker_items, {
                                                modelValue: condition.value,
                                                "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                            ]))
                                          : (condition.valueType === _ctx.ValueType.deviceOrgType)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                                _hoisted_35,
                                                _createVNode(_component_el_button, {
                                                  size: "default",
                                                  icon: "Plus",
                                                  type: "primary",
                                                  onClick: ($event: any) => (_ctx.deviceOrgTypePickerOpen(condition.value)),
                                                  round: ""
                                                }, {
                                                  default: _withCtx(() => [
                                                    _hoisted_36
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"]),
                                                _createVNode(_component_picker_items, {
                                                  modelValue: condition.value,
                                                  "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                              ]))
                                            : (condition.valueType === _ctx.ValueType.selectOrgType)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                                  _hoisted_38,
                                                  _createVNode(_component_el_button, {
                                                    size: "default",
                                                    icon: "Plus",
                                                    type: "primary",
                                                    onClick: ($event: any) => (_ctx.selectOrgTypePickerOpen(condition.value)),
                                                    round: ""
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _hoisted_39
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _createVNode(_component_picker_items, {
                                                    modelValue: condition.value,
                                                    "onUpdate:modelValue": ($event: any) => ((condition.value) = $event)
                                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                                ]))
                                              : (condition.valueType === _ctx.ValueType.date)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_40))
                                                : _createCommentVNode("", true),
                          _createVNode(_component_el_icon, {
                            class: "el-icon-delete",
                            style: {"right":"10px"},
                            onClick: ($event: any) => (_ctx.rmSubCondition(group, cindex))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 2
                }, 1536)
              ]))
        ])
      ]))
    }), 128)),
    _createVNode(_component_org_picker, {
      ref: "orgPicker",
      multiple: "",
      selected: _ctx.orgList,
      onOk: _ctx.orgSelected
    }, null, 8, ["selected", "onOk"]),
    _createVNode(_component_org_type_picker, {
      ref: "orgTypePicker",
      multiple: "",
      selected: _ctx.orgTypeList,
      onOk: _ctx.orgTypeSelected
    }, null, 8, ["selected", "onOk"]),
    _createVNode(_component_dept_picker, {
      ref: "deptPicker",
      multiple: "",
      selected: _ctx.deptList,
      onOk: _ctx.deptSelected
    }, null, 8, ["selected", "onOk"]),
    _createVNode(_component_post_picker, {
      ref: "postPicker",
      multiple: "",
      selected: _ctx.postList,
      onOk: _ctx.postSelected
    }, null, 8, ["selected", "onOk"]),
    _createVNode(_component_user_picker, {
      ref: "userPicker",
      multiple: "",
      selected: _ctx.userList,
      onOk: _ctx.userSelected
    }, null, 8, ["selected", "onOk"]),
    _createVNode(_component_org_picker, {
      ref: "deviceOrgPicker",
      multiple: "",
      selected: _ctx.deviceOrgList,
      onOk: _ctx.deviceOrgSelected
    }, null, 8, ["selected", "onOk"]),
    _createVNode(_component_org_type_picker, {
      ref: "deviceOrgTypePicker",
      multiple: "",
      selected: _ctx.deviceOrgTypeList,
      onOk: _ctx.deviceOrgTypeSelected
    }, null, 8, ["selected", "onOk"]),
    _createVNode(_component_org_type_picker, {
      ref: "selectOrgTypePicker",
      multiple: "",
      selected: _ctx.selectOrgTypeList,
      onOk: _ctx.selectOrgTypeSelected
    }, null, 8, ["selected", "onOk"])
  ]))
}